const funProto = Function.prototype;
const objProto = Object.prototype;

const getPrototypeOf = Object.getPrototypeOf;

const objToString = objProto.toString;
const hasOwnProperty = objProto.hasOwnProperty;
const funToString = funProto.toString;

// 谓词函数
// --------------------------------------------------------------------------------
const is = {
    mobile: function() {
        return /mobile/i.test(navigator.userAgent.toLowerCase());
    },
    element: function(value) {
        return !!(value && value.nodeType === 1);
    },
    null: function(value) {
        return value === null;
    },
    undefined: function(value) {
        return value === void 0;
    },
    nan: function(value) {
        return window.isNaN(value) && value !== value;
    },
    number: function(value) {
        return objToString.call(value) === "[object Number]" && !is.nan(value);
    },
    string: function(value) {
        return objToString.call(value) === "[object String]";
    },
    boolean: function(value) {
        return value === true || value === false || objToString.call(value) === "[object Boolean]";
    },
    regexp: function(value) {
        return objToString.call(value) === "[object RegExp]";
    },
    date: function(value) {
        return objToString.call(value) === "[object Date]" && !is.nan(value.getTime());
    },
    function: function(value) {
        return objToString.call(value) === "[object Function]" || typeof value === "function";
    },
    array: function(value) {
        return objToString.call(value) === "[object Array]";
    },
    object: function(value) {
        return !!value && typeof value === "object";
    },
    json: function(value) {
        if (!value || objToString.call(value) !== "[object Object]") {
            return false;
        }

        const prototype = getPrototypeOf(value);

        if (prototype === null) {
            return true;
        }

        const constructor = hasOwnProperty.call(prototype, "constructor") && prototype.constructor;

        return typeof constructor === "function" && funToString.call(constructor) === funToString.call(Object);
    }
};

// 工具函数
// --------------------------------------------------------------------------------
const utils = {
    clone: function(object) {
        if (!is.array(object) && !is.json(object)) {
            return object;
        }

        let copy = is.array(object) ? [] : {};

        for (let key in object) {
            if (hasOwnProperty.call(object, key)) {
                let value = object[key];

                copy[key] = utils.clone(value);
            }
        }

        return copy;
    },
    assign: function(object) {
        const length = arguments.length;

        if (object === null || length === 0) {
            return object;
        }

        for (let index = 0; index < length; index++) {
            const source = arguments[index];

            if (!is.json(source)) {
                continue;
            }

            const keys = Object.keys(source);
            const keysLength = keys.length;

            for (let i = 0; i < keysLength; i++) {
                const key = keys[i];

                object[key] = utils.clone(source[key]);
            }
        }

        return object;
    },
    addEventListener: function(target, type, listener, option) {
        if (target.addEventListener) {
            let useCapture = false;

            if (typeof option === "object") {
                useCapture = option.capture || false;
            }
            else if (typeof option === "boolean") {
                useCapture = option;
            }

            target.addEventListener(type, listener, option || false);

            return {
                remove() {
                    target.removeEventListener(type, listener, useCapture);
                }
            };
        }
        else if (target.attachEvent) {
            target.attachEvent("on" + type, listener);

            return {
                remove() {
                    target.detachEvent("on" + type, listener);
                }
            };
        }
    }
};

// 请求
// --------------------------------------------------------------------------------
const http = {
    factory: null,
    factories: [
        function() {
            return new XMLHttpRequest();
        },
        function(){
            return new ActiveXObject("Msxm12.XMLHTTP");
        },
        function(){
            return new ActiveXObject("Microsoft.XMLHTTP");
        }
    ],
    createXhr: function() {
        if (this.factory !== null) {
            return this.factory();
        }

        for (let i = 0, length = this.factories.length; i < length; i++) {
            try {
                const factory = this.factories[i];
                const xhr = factory();

                if (xhr !== null) {
                    this.factory = factory;

                    return xhr;
                }
            }
            catch(e) {
                continue;
            }
        }

        this.factory = function() {
            throw new Error("XMLHttpRequest not supported");
        };

        this.factory();
    },
    ajax: function(options) {
        let
        method = options.method || "GET",
        url = options.url || "",
        data = options.data || null,
        async = options.async === undefined ? true : options.async,
        success = options.success,
        error = options.error,
        complete = options.complete,
        formatData = function(data) {
            let result = "";

            if (is.string(data)) {
                result = data;
            }
            else if (is.json(data)) {
                data["timestamp"] = new Date().getTime();

                let parts = [];

                for (let key in data) {
                    parts.push(key + "=" + encodeURIComponent(data[key]));
                }

                result = parts.join("&");
            }

            return result;
        },
        getResponse = function(xhr) {
            const response = xhr.responseText || xhr.response;

            if (!response) {
                return response;
            }

            try {
                return JSON.parse(response);
            }
            catch(e) {
                return response;
            }
        },
        getError = function(method, url, xhr) {
            var message;

            if (xhr.response) {
                message = xhr.response.error || xhr.response;
            }
            else if (xhr.responseText) {
                message = xhr.responseText;
            }
            else {
                message = "fail to request " + url + " " + xhr.status;
            }

            var error = new Error(message);

            error.method = method;
            error.url = url;
            error.status = xhr.status;

            return error;
        },
        onStateChange = function(xhr, success, error, complete) {
            if (xhr.readyState === 4) {
                var status = xhr.status;

                if (status >= 200 && status < 300) {
                    if (is.function(success)) {
                        success(getResponse(xhr));
                    }
                }
                else {
                    if (is.function(error)) {
                        error(getError(options.method, options.url, xhr));
                    }
                }

                if (is.function(complete)) {
                    complete(xhr);
                }
            }
        };

        method = method.toUpperCase();
        data = formatData(data);

        const xhr = http.createXhr();

        if (method == "GET") {
            url = url + (url.indexOf("?") === -1 ? "?" : "&") + data;
            data = null;
        }

        xhr.open(method, url, async);

        if (method == "POST") {
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        }

        xhr.onreadystatechange = function() {
            onStateChange(xhr, success, error, complete);
        };

        xhr.send(data);

        return xhr;
    }
};

// 电魂通行证登陆主逻辑
// --------------------------------------------------------------------------------
var msLogin = {};

// 默认选项
msLogin.defaults = {
    registerUrl: "https://passport.m3guo.com/register.aspx",
    loginUrl: "",
    callbackUrl: ""
};

// 打开登录弹窗
msLogin.open = function(options) {
    // 未初始化时先进行初始化
    if (!msLogin.initialized) {
        this.defaults = utils.assign({}, this.defaults, options);

        this.el = {};

        this.el.backdrop = document.createElement("div");
        this.el.backdrop.id = "msLogin-backdrop";
        this.el.backdrop.style = "position: fixed; top: 0; bottom: 0; left: 0; right: 0; z-index: 1000000; width: 100%; height: 100%; background-color: rgba(0,0,0,0.8);";

        this.el.popup = document.createElement("div");
        this.el.popup.id = "msLogin-popup";
        this.el.popup.style = "position: fixed; top: 50%; left: 50%; z-index: 1000001; width: 562px; height: 432px; border-radius: 2px; -webkit-transform: translate(-50%,-50%); -moz-transform: translate(-50%,-50%); transform: translate(-50%,-50%);";

        this.el.iframe = document.createElement("iframe");
        this.el.iframe.src = "";
        this.el.iframe.frameborder = "0";
        this.el.iframe.scrolling = "no";
        this.el.iframe.style = "display: block; width: 100%; height: 100%; border: none;";

        this.el.btnClose = document.createElement("div");
        this.el.btnClose.href ="javascript:;";
        this.el.btnClose.style = "position: absolute; top: 10px; right: 10px; cursor: pointer; display: block; width: 16px; height: 16px; user-select: none; text-align: center; line-height: 16px; color: #ff6600; font-size: 16px; -webkit-transition: color 0.3s; -moz-transition: color 0.3s; transition: color 0.3s;";
        this.el.btnClose.innerHTML = "&#10005";

        this.el.popup.appendChild(this.el.iframe);
        this.el.popup.appendChild(this.el.btnClose);
    }

    // 请求相关配置并执行打开操作
    let data = {};

    http.ajax({
        method: "POST",
        url: this.defaults.loginUrl,
        data: {
            mod: "getauthorizedurl",
            callback: encodeURIComponent(this.defaults.callbackUrl),
            timestamp: new Date().getTime()
        },
        success: response => {
            if (is.string(response)) {
                response = JSON.parse(response);
            }

            if ("code" in response) {
                if (response["code"] === 0) {
                    data = response["data"];
                }
                else {
                    data["resultcode"] = -1;
                }
            }
            else if ("resultcode" in response) {
                data = response;
            }
        },
        error: e => {
            data["resultcode"] = -1;
        },
        complete: xhr => {
            const code = data["resultcode"];

            if (code === 0 || code === 1) {
                var search = "?token=" + encodeURI(data["auto_token"]) + "&regurl=" + encodeURI(this.defaults.registerUrl) + "&denycallbackurl=" + this.defaults.loginUrl + "&timestamp=" + new Date().getTime();

                if (is.mobile()) {
                    window.location.href = "https://login.17m3.com/oauth/loginSDK.html" + search;
                }
                else{
                    this.el.iframe.src = data["callbackurl"] + search;
                }

                this.closeEvent = utils.addEventListener(this.el.btnClose, "click", () => this.close());

                document.body.appendChild(this.el.backdrop);
                document.body.appendChild(this.el.popup);
            }
            else {
                alert("网络异常，请刷新页面后重试");
            }
        }
    })
};

// 关闭登录弹窗
msLogin.close = function() {
    this.closeEvent && this.closeEvent.remove();

    document.body.removeChild(this.el.backdrop);
    document.body.removeChild(this.el.popup);
};

export default msLogin;


// WEBPACK FOOTER //
// ./src/js/msLogin.js